<template>
  <div class="container">
    <div class="content">
      <div class="top">
        <div class="center" :style="note">
          <div style="width: 50%">
            <img style="" width="86%" height="90%" :src="zyImg" />
          </div>
          <div
            style="
              width: 50%;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 10%;
            "
          >
            <div
              style="
                height: 86px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
              "
            >
              <img width="20%" height="70%" :src="logoImg" />
              <font
                letter-spacing="12px"
                size="5.6"
                font-weight="500"
                color="#5E667A"
                >订单门户网站</font
              >
            </div>
            <component
              :is="componentName"
              @regist="handleRegist"
              class="main-content"
            ></component>
          </div>
        </div>
        <div class="desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalFooter from '../common/GlobalFooter'
import Login from './LoginEl'
import Regist from './Regist'

export default {
  name: 'Common',
  components: { GlobalFooter, Login, Regist },
  data() {
    return {
      componentName: 'Login',
      jxImg: require('../../assets/img/jx.png'),
      zyImg: require('../../assets/img/zy.png'),
      logoImg: require('../../assets/img/login_logo.png'),
      note: {
        backgroundImage: "url(" + require('../../assets/img/jx.png') + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "68%",
        height: "83%"
      },
    }
  },
  computed: {
    systemName() {
      /!*return this.$store.state.setting.systemName*!/
    },
    copyright() {
      /!*return this.$store.state.setting.copyright*!/
    }
  },
  methods: {
    handleRegist(val) {
      this.componentName = val
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  opacity: 0.71;
  overflow: auto;
  background: #f0f2f5 url("../../assets/img/bj1.png") no-repeat center;
  background-size: 100% 100%;
}
.content {
  flex: 1;
}
.top {
  text-align: center;
}
.center {
  margin: 100px auto;
  width: 68%;
  height: 83%;
}

.main-content {
  width: 70%;
  margin-top: 6%;
}
</style>